import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";


//Vue Toast
//======================================================
import "vue-toast-notification/dist/theme-default.css";
import VueToast from "vue-toast-notification";
Vue.use(VueToast, {
  position: "top-right",
});

//Vue Mask
//======================================================
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

//Vue SmoothScroll
//======================================================
import vueSmoothScroll from "vue2-smooth-scroll";
Vue.use(vueSmoothScroll);

//Vue Bootstrap
//======================================================
import { BootstrapVue } from "bootstrap-vue";
Vue.use(BootstrapVue);
import "bootstrap/dist/css/bootstrap.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-vue/dist/bootstrap-vue.css";

//VeeValidate
//======================================================
import {
  localize,
  extend,
  ValidationProvider,
  ValidationObserver,
  configure,
} from "vee-validate";
import {
  required,
  email,
  min,
  max,
  confirmed,
  min_value,
  max_value,
  alpha,
  alpha_dash,
  alpha_spaces,
} from "vee-validate/dist/rules";
extend("confirmed", confirmed);
extend("min", min);
extend("max", max);
extend("required", required);
extend("email", email);
extend("min_value", min_value);
extend("max_value", max_value);
extend("alpha", alpha);
extend("alpha_dash", alpha_dash);
extend("alpha_spaces", alpha_spaces);

//Regras customizadas
import validacaoDataNascimento from "./helpers/validacaoDataNascimento";
import validacaoDataMaiorDeIdade from "./helpers/validacaoDataMaiorDeIdade";
import validacaoCPF from "./helpers/validacaoCPF";
import validacaoCNPJ from "./helpers/validacaoCNPJ";
import validacaoExpiracaoCartaoCredito from "./helpers/validacaoExpiracaoCartaoCredito";
import validacaoNomeCompleto from "./helpers/validacaoNomeCompleto";
import validacaoData from "./helpers/validacaoData";
import validacaoDataHoje from "./helpers/validacaoDataHoje";
import validacaoTelefone from "./helpers/validacaoTelefone";
import validacaoSenha from "./helpers/validacaoSenha";

extend("data_nascimento", validacaoDataNascimento);
extend("data_maior_idade", validacaoDataMaiorDeIdade);
extend("cpf", validacaoCPF);
extend("cnpj", validacaoCNPJ);
extend("expiracao_cartao", validacaoExpiracaoCartaoCredito);
extend("nome_completo", validacaoNomeCompleto);
extend("data_valida", validacaoData);
extend("data_hoje", validacaoDataHoje);
extend("validacao_telefone", validacaoTelefone);
extend("password_rules", validacaoSenha);


import pt_BR from "vee-validate/dist/locale/pt_BR.json";
localize("pt_BR", pt_BR);
configure({
  classes: {
    // valid: 'is-valid',
    invalid: "is-invalid",
  },
});
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

//VueClipboard
//======================================================
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

//Inicialização principal
//======================================================
Vue.config.productionTip = false;
Vue.config.ignoredElements = ["lottie-player"];

//Interceptor
//======================================================
import "./interceptor";

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
